/** Figma arrow-down-to-line — outer 16×16, leaf inset 12.5% / 20.83% (I2181:7659;1590:9196) */
const ArrowDownToLineIcon = () => {
    return (
        <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[12.5%_20.83%]">
                <span className="absolute inset-[-6%]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="13"
                        viewBox="0 0 10 13"
                        fill="none"
                    >
                        <path
                            d="M5.00004 9.66634V0.333008M9.00004 5.66634L5.00004 9.66634L1.00004 5.66634M9.66671 12.333H0.333374"
                            stroke="#283A97"
                            stroke-width="0.666667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </span>
            </span>
        </span>
    );
};

export default ArrowDownToLineIcon;
